
import { Component, Prop, Vue } from 'nuxt-property-decorator'
import { MobileOfferDTO, HomeOfferDTO } from '@alao-frontend/core'
import Loader from '~/components/Loader.vue'
import OfferSliderSection from '~/components/sections/5-reasons-why/TopOffersSlider.vue'

@Component({
  components: {
    OfferSliderSection,
    Loader,
  },
})
export default class BlackFridayOfferSlider extends Vue {
  @Prop({ type: Boolean, default: true, required: false })
  readonly isLoading!: boolean

  @Prop({ type: String, required: false })
  readonly title!: string

  @Prop({ type: Array })
  readonly offers!: HomeOfferDTO[] | MobileOfferDTO[]

  get slidePerViewForOffers () {
    if (this.$mqUtils.isXXL || this.$mqUtils.isXL || this.$mqUtils.isXXXL) {
      return 2
    }
    return 1
  }
}
